<template>
    <div class="public_container">
        <div class="mobile_login_container">
            <div class="phone_login_board">
                <img alt="" src="https://download.hecoos.com/enlightv/2024-32/xsYhfHKXPAECwMcAJFRD.png" class="sass_icon">
                <ul :class="login_type==='1'?'bottom_border_30':'bottom_border_160'" class="login_type_list">
                    <li :class="{'active':login_type==='1'}" @click="handleClickLoginType('1','phoneLoginForm')"
                        class="login_type_item">
                        验证码登录
                    </li>
                    <li :class="{'active':login_type==='2'}" @click="handleClickLoginType('2','phoneLoginForm')"
                        class="login_type_item">
                        密码登录
                    </li>
                </ul>
                <el-form :model="loginForm" :rules="loginFormRules"  ref="phoneLoginForm">
                    <el-form-item prop="phone">
                        <el-input placeholder="手机号" v-model="loginForm.phone"></el-input>
                    </el-form-item>
                    <el-form-item prop="code" v-if="login_type==='1'">
                        <el-input maxlength="6" placeholder="验证码" v-model="loginForm.code">
                            <el-button :disabled="getCodeBtnDisabled" @click="handleClickGetCode('phoneLoginForm')"
                                       slot="suffix"
                                       type="text">
                                {{getCodeText}}
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password" v-if="login_type==='2'">
                        <el-input placeholder="密码" show-password v-model="loginForm.password"></el-input>
                    </el-form-item>
                    <div class="forget_register_wrap" v-if="login_type==='2'">
                        <span @click="handleClickForgetPwd" class="forget_btn">忘记密码？</span>
                    </div>
                    <div style="height: 37px" v-if="login_type==='1'"></div>
                    <div class="agree_check_wrap">
                        <el-checkbox v-model="loginForm.agree"></el-checkbox>
                        <span class="agreement_text">我已阅读并同意
                        <span @click="agreementShow=true" style="color: #1990ff;cursor: pointer">《隐私保护协议》</span></span>
                    </div>
                    <el-form-item>
                        <el-button @click="handleClickLogin('phoneLoginForm')" class="login_btn" type="primary">登录
                        </el-button>
                    </el-form-item>
                    <div class="wechat_login_flex_wrap">
                        <div class="wechat_login_icon_wrap">
                            <img @click="handleClickWechatLogin"
                                 alt=""
                                 class="wechat_login_icon"
                                 ref="wechat_login_icon"
                                 src="https://download.hecoos.com/enlightv/2024-02/N5ktWHcPQeDjFsBe8FNa.png">
                        </div>
                        <div @click="handleClickRegisteringCompany" class="registering_btn">
                            注册新公司
                        </div>
                    </div>

                </el-form>
            </div>
        </div>
        <van-popup :style="{ height: '503px' }" position="bottom" round v-model="agreementShow"   get-container="body" :lock-scroll="true">
            <div class="agreement_wrap">
                <h2>注册协议</h2>
                <p>欢迎您使用澜精灵的服务！</p>
                <p>
                    为使用澜精灵的服务，您应当阅读并遵守《澜精灵服务协议》（以下简称“本协议”）和《澜精灵隐私政策》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制澜精灵责任的条款、对用户权利进行限制的条款、约定争议解决方式和司法管辖的条款等，以及开通或使用某项服务的单独协议或规则。限制、免责条款或者其他涉及您重大权益的条款可能以加粗、加下划线等形式提示您重点注意。</p>
                <p>
                    除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权使用澜精灵服务。您点击“同意”或“下一步”，或您使用澜精灵服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。本协议即在您与澜精灵之间产生法律效力，成为对双方均具有约束力的法律文件。</p>
                <p>如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称"监护人"）的陪同下阅读和判断是否同意本协议，并特别注意未成年人使用条款。</p>
                <p>如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。</p>
                <h5>一、协议范围</h5>
                <p>1.1
                    本协议是用户与澜精灵之间关于其使用澜精灵的服务所订立的协议。“澜精灵”是指北京澜景科技有限公司和/或其相关服务可能存在的运营关联单位。“用户”是指澜精灵的服务的使用人，在本协议中也称为“您”。</p>
                <p>1.2
                    澜精灵的服务，包括但不限于网络媒体、互联网增值、互动娱乐、广告等物品及服务，具体服务以澜精灵实际提供的为准（以下简称“本服务”）。</p>
                <p>1.3
                    本协议内容同时包括《澜精灵隐私政策》,且您在使用澜精灵某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何单独协议的接受，即视为您对本协议全部的接受。您对本协议的接受，即视为您对《澜精灵隐私政策》的接受。</p>
                <h5>二、帐号与密码</h5>
                <p>2.1 您在使用本服务时可能需要注册一个帐号。</p>
                <p>2.2 您应妥善保管帐号和密码。使用完毕后，应安全退出。因保管不善可能导致遭受被盗号或密码失窃，责任由您自行承担。</p>
                <p>2.3 您应当保证昵称、头像、签名、留言、图片、简介等信息的内容和形式符合法律法规和有关政策、公序良俗、社会公德以及澜精灵规则，且不会侵害任何主体的合法权益。</p>
                <h5>三、用户个人信息保护</h5>
                <p>3.1 保护用户个人信息是澜精灵的一项基本原则。</p>
                <p>3.2 澜精灵将按照本协议及《澜精灵隐私政策》的规定收集、使用、储存和分享您的个人信息。</p>
                <p>3.3 您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则可能无法使用本服务或在使用过程中受到限制。</p>
                <h5>四、使用本服务的方式</h5>
                <p>4.1 您依本协议条款所取得的权利不可转让。</p>
                <p>4.2
                    您不得使用任何方式（包括但不限于第三方软件、插件、外挂、系统、设备等）对本服务进行干扰、破坏、修改或施加其他影响，也不得通过任何第三方软件、插件、外挂、系统、设备等登录或使用本服务、查看和获取本服务中所包含的澜精灵、澜精灵合作伙伴或用户的任何相关信息、数据等内容。</p>
                <h5>五、广告</h5>
                <p>5.1
                    您同意澜精灵可以自行或由第三方通过短信、电子邮件或电子信息等多种方式向您发送、展示广告或其他信息（包括商业与非商业信息），广告或其他信息的具体发送及展示形式、频次及内容等以澜精灵实际提供为准。</p>
                <p>5.2 澜精灵将依照相关法律法规要求开展广告业务。您同意，对本服务中出现的广告，您应审慎判断其真实性和可靠性，除法律明确规定外，您应对因该广告而实施的行为负责。</p>
                <h5>六、服务费用</h5>
                <p>6.1 澜精灵未来可能以收费的方式提供某些服务，如您使用收费服务，请遵守相关的协议。</p>
                <p>6.2
                    澜精灵可能根据实际需要对收费服务的收费标准、方式进行修改和变更，澜精灵也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，澜精灵将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。</p>
                <p>6.3
                    在澜精灵未来降低收费服务的收费标准或者将收费服务改为免费服务提供时，澜精灵保留不对原付费用户提供退费或者费用调整之权利。</p>
                <h5>七、第三方提供的物品或服务</h5>
                <p>
                    您在澜精灵平台上使用第三方提供的物品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。澜精灵和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
                <h5>八、基于软件提供服务</h5>
                <p>8.1
                    您在使用本服务的过程中可能需要下载某些软件，对于该些软件，澜精灵给予您一项个人的、不可转让及非排他性的许可。您仅可为使用本服务的目的而使用这些软件。如果您从未经澜精灵授权的第三方获取软件或与软件名称相同的安装程序，澜精灵无法保证该软件或服务能够正常使用，并对因此给您造成的损失不予负责。</p>
                <p>8.2 澜精灵可能会根据需要对软件进行不时更新。您应该将相关软件更新到最新版本，否则澜精灵不保证软件或服务能正常使用。</p>
                <h5>九、知识产权</h5>
                <p>9.1
                    澜精灵在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归澜精灵所有，用户在使用本服务中所产生内容的知识产权归用户或相关权利人所有，除非您与澜精灵另有约定。</p>
                <p>9.2 上述知识产权受到法律法规保护，未经权利人书面许可，任何人不得以任何形式进行使用，也不得以此为基础创造相关衍生作品。</p>
                <h5>十、用户违法违规行为及处理</h5>
                <p>10.1 您在使用本服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利</p>
                <p><span>（1）反对宪法所确定的基本原则的。</span></p>
                <p><span>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。</span></p>
                <p><span>（3）损害国家荣誉和利益的。</span></p>
                <p><span>（4）煽动民族仇恨、民族歧视，破坏民族团结的。</span></p>
                <p><span>（5）破坏国家宗教政策，宣扬邪教和封建迷信的。</span></p>
                <p><span>（6）散布谣言，扰乱社会秩序，破坏社会稳定的。</span></p>
                <p><span>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。</span></p>
                <p><span>（8）侮辱或者诽谤他人，侵害他人合法权益的。</span></p>
                <p><span>（9）违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的。</span></p>
                <p><span>（10）相关法律法规或本协议、相关协议、规则等禁止的。</span></p>
                <p>10.2
                    如果您在使用本服务过程中违反了相关法律法规或本协议约定，有关国家机关或机构可能会对您进行行政处罚、追究刑事责任或采取其他制裁措施，并要求澜精灵给予协助。因此给您或者他人造成损害的，您自行承担全部责任，澜精灵不承担任何责任。</p>
                <p>10.3 如果您违反本协议约定，澜精灵有权独立进行判断并采取相应措施，包括但不限于通过技术手段删除、屏蔽相关内容或断开链接、暂停或终止向您提供服务等措施。</p>
                <p>10.4 您违反本协议约定，导致任何主体（包括澜精灵）损失的，您应当独立承担责任。</p>
                <h5>十一、遵守法律和监管</h5>
                <p>11.1 您在使用本服务过程中应当遵守中华人民共和国相关的法律法规、公序良俗。否则，您应当为此独立承担责任。</p>
                <p>11.2 您应避免因使用本服务而使澜精灵违反法律法规或卷入政治和公共事件，否则澜精灵有权暂停或终止对您的服务。</p>
                <h5>十二、不可抗力及其他免责事由</h5>
                <p>12.1
                    在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为、现有技术限制等。出现上述情况时，澜精灵将努力争取及时进行处理，但是由此给您造成的损失澜精灵在法律允许的范围内免责。</p>
                <p>12.2 在法律允许的范围内，澜精灵对以下情形导致的服务中断或受阻不承担责任：</p>
                <p><span>（1）用户操作不当或用户通过非澜精灵授权的方式使用本服务。</span></p>
                <p><span>（2）程序版本过时、设备的老化和/或其兼容性问题。</span></p>
                <p><span>（3）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏。</span></p>
                <p><span>（4）用户或澜精灵的电脑软件、系统、硬件和通信线路出现故障。</span></p>
                <p><span>（5）其他澜精灵无法控制或合理预见的情形。</span></p>
                <p>12.3
                    在使用本服务的过程中，您可能会遇到网络信息或其他用户行为带来的风险，澜精灵不对该些信息的真实性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：</p>
                <p><span>（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息。</span></p>
                <p><span>（2）遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失。</span></p>
                <p><span>（3）其他因网络信息或用户行为引起的风险。</span></p>
                <p>12.4 澜精灵依据本协议约定获得处理违法违规内容的权利，该权利不构成澜精灵的义务或承诺，
                    澜精灵不能保证及时发现违法行为或进行相应处理。</p>
                <h5>十三、协议的生效与变更</h5>
                <p>13.1 您使用本服务即视为您已阅读本协议并接受本协议的约束。</p>
                <p>13.2
                    澜精灵有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。本协议条款变更后，如果您继续使用澜精灵提供的软件或服务，即视为您已接受变更后的协议。</p>
                <h5>十四、服务的变更、中断、终止</h5>
                <p>14.1 您理解并同意，澜精灵基于经营策略调整或者其他各方面的原因，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</p>
                <p>14.2
                    在澜精灵发生合并、分立、收购、资产转让时，澜精灵可向第三方转让本服务下相关资产；澜精灵也可在未经通知您的情况下，将本协议下部分或全部服务及相应的权利义务转交由第三方运营或履行。</p>
                <p>14.3
                    您有责任自行备份存储在本服务中的数据。如果您的服务被终止，澜精灵有权从服务器上永久地删除您的数据,法律法规另有规定的除外。服务中止或终止后，澜精灵没有义务向您提供或返还数据。</p>
                <h5>十五、无民事行为能力人或限制民事行为能力人使用条款</h5>
                <p>15.1 民事行为能力不完整的用户，应在监护人监护、指导下阅读本协议和使用本服务。</p>
                <p>15.2 民事行为能力不完整的用户在使用本服务时应注意以下事项，提高安全意识，加强自我保护：</p>
                <p><span>（1）认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活。</span></p>
                <p><span>（2）填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰。</span></p>
                <p><span>（3）在监护人或老师的指导下，学习正确使用网络。</span></p>
                <p><span>（4）避免陌生网友随意会面或参与联谊活动，以免不法分子有机可乘，危及自身安全。</span></p>
                <p>15.3 监护人、学校均应对民事行为能力不完整的用户使用本服务多做引导。</p>
                <h5>十六、法律适用与管辖</h5>
                <p>16.1 本协议签订地为中华人民共和国北京市海淀区。</p>
                <p>16.2 本协议的成立、生效、履行、解释及纠纷解决等相关事宜，均适用中华人民共和国大陆地区法律。</p>
                <p>16.3 若您和澜精灵之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地（即中国北京市）有管辖权的人民法院管辖。</p>
                <div class="agreement_btn_wrap">
                    <van-button type="info" block round @click="handleClickHasRead">我已阅读</van-button>
                </div>
            </div>

        </van-popup>
    </div>
</template>
<script>
import { SendPhoneCode, AccountLogin, wechatLogin,GetUserInfo } from "@/api/index";
export default {
    name: 'mobileIndex',
    data () {
        return {
            login_type:'1',
            loginForm: {
                password: '',
                phone: '',
                code: '',
                agree: true
            },
            getCodeTime: 60,
            getCodeBtnDisabled: false,
            loginFormRules: {
                phone: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入手机号'))
                            if (!/^1[3456789]\d{9}$/.test(value)) return callback(new Error('请输入正确的手机号'))
                            callback()
                        }
                    },
                ],
                password: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请输入密码'
                    }
                ],
                code: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value) return callback(new Error('请输入验证码'))
                            if (!/^\d{6}$/.test(value)) return callback(new Error('请输入6位验证码'))
                            callback()
                        }
                    },
                ],
            },
            agreementShow: false,
        }
    },
    computed: {
        getCodeText() {
            if (this.getCodeBtnDisabled) {
                return `${this.getCodeTime}秒后重新发送`;
            } else {
                return '获取验证码';
            }
        }
    },
    created() {
        console.log(this.$route);
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const appid = urlParams.get('appid');
        if(code && state && appid){
            this.exchangeCodeForToken(code, state,appid);
        }
        console.log(code);
        console.log(state);
        console.log(appid);
    },
    mounted () {

    },
    methods: {
        // 切换登录方式
        handleClickLoginType(login_type,ref){
            this.login_type = login_type
        },
        // 获取验证码
        handleClickGetCode(ref) {
            this.$refs[ref].validateField("phone", (valid) => {
                if (!valid) {
                    SendPhoneCode({
                        phone: this.loginForm.phone,
                        type: "login",
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$toast("验证码发送成功");
                            this.getCodeBtnDisabled = true;
                            const timer = setInterval(() => {
                                if (this.getCodeTime > 0) {
                                    this.getCodeTime--;
                                } else {
                                    this.getCodeBtnDisabled = false;
                                    clearInterval(timer);
                                    this.getCodeTime = 60;
                                }
                            }, 1000);
                        } else {
                            this.$toast(res.message);
                        }
                    });
                }
            });
        },
        // 忘记密码
        handleClickForgetPwd() {
            this.$router.push({
                name: 'mobileForgot'
            })
        },
        // 登录
        handleClickLogin(ref) {
            this.$refs[ref].validate((valid) => {
                if (valid) {
                    if (!this.loginForm.agree) {
                        return this.$toast("请先勾选同意隐私保护协议");
                    }
                    let data;
                    if (this.login_type === "1") {
                        data = {
                            phone: this.loginForm.phone,
                            code: this.loginForm.code,
                        };
                    } else {
                        data = {
                            phone: this.loginForm.phone,
                            password: this.loginForm.password,
                        };
                    }
                    AccountLogin(data)
                        .then((res) => {
                            if (res.code == 200) {
                                const { data } = res
                                if (data && data.token) {
                                    this.$store.dispatch("saveUserInfo", data);
                                    this.$toast({
                                        message: "登录成功",
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            if(data.company_id){
                                                this.$router.push({
                                                    name: 'mobileWorkBench'
                                                })
                                            }else{
                                                this.$router.push({
                                                    name: 'mobileNoCompany'
                                                })
                                            }

                                        },
                                    });
                                }
                            }
                        })
                        .catch((err) => {

                        });
                } else {
                    return false;
                }
            });
        },
        getUserInfo(data) {
            GetUserInfo({}).then((res) => {
                if (res.code == 200) {
                    const userInfo = { token:data.token, ...res.data };
                    this.$store.dispatch("saveUserInfo", userInfo);
                    this.$toast({
                        message: "登录成功",
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            if(data.company_id){
                                this.$router.push({
                                    name: 'mobileWorkBench'
                                })
                            }else{
                                this.$router.push({
                                    name: 'mobileNoCompany'
                                })
                            }

                        },
                    });
                }
            });
        },
        // 微信登录
        handleClickWechatLogin() {
            if (!this.loginForm.agree)
            return this.$toast("请先勾选同意隐私保护协议");
            window.location.href = "/api/Wechat/getAuthUrl";
        },
        exchangeCodeForToken(code, state,appid){
            this.$toast.loading({
                message: '正在登录,请稍后...',
                forbidClick: true
            });
            wechatLogin({code,state,appid}).then((res) => {
                if (res.code === 200) {
                    let {is_registered,company_id,headimgurl,nickname,openid,sex} = res.data.user
                    let origin = window.location.origin;
                    let pathname = window.location.pathname;
                    this.$toast.clear();
                    if(is_registered){
                        const { user } = res.data
                        if (user && user.token) {
                            this.$store.dispatch("saveUserInfo", user);
                            this.$toast({
                                message: "登录成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    if(user.company_id){
                                        // this.$router.push({
                                        //     name: 'mobileWorkBench'
                                        // })
                                        let href = `${origin}${pathname}#/workBench`
                                        window.location = href
                                    }else{
                                        // this.$router.push({
                                        //     name: 'mobileNoCompany'
                                        // })
                                        let href = `${origin}${pathname}#/noCompany`
                                        window.location = href
                                    }

                                },
                            });
                        }
                    }else{
                        let href = `${origin}${pathname}#/binding?avatar=${headimgurl}&name=${nickname}&openid=${openid}&gender=${sex}`
                        window.location = href
                    }
                } else {
                    this.$toast(res.message);
                }

            });
        },
        // 注册新公司
        handleClickRegisteringCompany(){
            this.$router.push({
                name: 'mobileRegisteringCompany'
            })
        },
        // 我已阅读
        handleClickHasRead() {
            this.agreementShow = false
            this.agree = true
        },
    },
    components: {}
}
</script>

<style lang="scss" scoped>
</style>
